import LoginToDashboard from './LoginToDashboard';

export default LoginToDashboard;
